import './bootstrap';

// admin-lte
require('admin-lte');
